// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/Fonts/N27-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/Images/view_btn.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: N27;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.card{
    /* background-image: url("../../assets/Images/CA_bg.png"); */
    background-size: 100% 100%;
    font-size: 30px;
    text-align: center;
    height: 328px;
    width: 280px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
}

.card-image{
    height: 235px;
    width: 235px;
}

.card h3{
    margin: 0;
    font-family: 'N27';
font-style: normal;
font-weight: 700;
font-size: 21.6508px;
line-height: 26px;
}

.card p{
    display: none;
    position: relative ;
    top: 25%;
    left: 20%;
}

.container{
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: black;
  opacity: 0;
}

.btn{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-color: transparent;
  width: 167px;
  height: 60px;
  border: none;
  position: absolute;
  background-repeat: no-repeat;
  background-size: 100%;
  top:40%;
  left: 20%;
  opacity:0;
  cursor: pointer;
  z-index: 0;
}

.card:hover .btn{
  opacity: 1.5;
}

.card:hover .container{
  opacity: 0.4;
}

@media only screen and (max-width: 600px){
    .card{
      height: 180px;
      width: 149px;
      padding: 5px;
    }

    .card-image {
      height: 130px;
      width: 140px;
  }

  .card h3{
    font-size: 14px;
  }
  .btn{
    top: 30%; 
    left: 0%;
    /* transform: scale(0.5); */
  }
  .card:hover .btn{
    opacity: 0;
  }
  
  .card:hover .container{
    opacity: 0;
  }


}`, "",{"version":3,"sources":["webpack://./src/components/CaCard/CaCard.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,4CAA8C;AAClD;;AAEA;IACI,4DAA4D;IAC5D,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB,kBAAkB;AAClB,gBAAgB;AAChB,oBAAoB;AACpB,iBAAiB;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,SAAS;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,yDAAyD;EACzD,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,qBAAqB;EACrB,OAAO;EACP,SAAS;EACT,SAAS;EACT,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;IACI;MACE,aAAa;MACb,YAAY;MACZ,YAAY;IACd;;IAEA;MACE,aAAa;MACb,YAAY;EAChB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,QAAQ;IACR,QAAQ;IACR,2BAA2B;EAC7B;EACA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;;AAGF","sourcesContent":["@font-face {\n    font-family: N27;\n    src: url(\"../../assets/Fonts/N27-Regular.otf\");\n}\n\n.card{\n    /* background-image: url(\"../../assets/Images/CA_bg.png\"); */\n    background-size: 100% 100%;\n    font-size: 30px;\n    text-align: center;\n    height: 328px;\n    width: 280px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n}\n\n.card-image{\n    height: 235px;\n    width: 235px;\n}\n\n.card h3{\n    margin: 0;\n    font-family: 'N27';\nfont-style: normal;\nfont-weight: 700;\nfont-size: 21.6508px;\nline-height: 26px;\n}\n\n.card p{\n    display: none;\n    position: relative ;\n    top: 25%;\n    left: 20%;\n}\n\n.container{\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  background-color: black;\n  opacity: 0;\n}\n\n.btn{\n  background-image: url(\"../../assets/Images/view_btn.png\");\n  background-color: transparent;\n  width: 167px;\n  height: 60px;\n  border: none;\n  position: absolute;\n  background-repeat: no-repeat;\n  background-size: 100%;\n  top:40%;\n  left: 20%;\n  opacity:0;\n  cursor: pointer;\n  z-index: 0;\n}\n\n.card:hover .btn{\n  opacity: 1.5;\n}\n\n.card:hover .container{\n  opacity: 0.4;\n}\n\n@media only screen and (max-width: 600px){\n    .card{\n      height: 180px;\n      width: 149px;\n      padding: 5px;\n    }\n\n    .card-image {\n      height: 130px;\n      width: 140px;\n  }\n\n  .card h3{\n    font-size: 14px;\n  }\n  .btn{\n    top: 30%; \n    left: 0%;\n    /* transform: scale(0.5); */\n  }\n  .card:hover .btn{\n    opacity: 0;\n  }\n  \n  .card:hover .container{\n    opacity: 0;\n  }\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
